export enum ClientTypes {
    Domestic = 1,
    International = 2,
}

export const ClientTypesMap = {
    [ClientTypes.Domestic]: 'Domestic',
    [ClientTypes.International]: 'International',
};
